let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fNM8r")).then(() => parcelRequire('5aQLI'));